<div class="admin-tab-client__card" [attr.data-testid]="'client-card-' + client().id">
  <div class="admin-tab-client__card-header">
    <h3 class="admin-tab-client__card-title">{{ client().name }}</h3>
    <div class="admin-tab-client__card-actions">
      <button
        mat-icon-button
        (click)="onEditClient()"
        [attr.data-testid]="'btn-edit-client-' + client().id"
        matTooltip="Edit client"
        class="admin-tab-client__edit-button"
      >
        <mat-icon>edit</mat-icon>
      </button>
      <button
        mat-icon-button
        color="warn"
        (click)="onDeleteClient()"
        [attr.data-testid]="'btn-delete-client-' + client().id"
        matTooltip="Delete client"
        class="admin-tab-client__delete-button"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>

  <div class="admin-tab-client__card-content">
    <!-- Wheel Links Section -->
    <div class="admin-tab-client__links-section">
      <h4 class="admin-tab-client__links-title">Wheel Links</h4>

      @if (client().assignedWheels && client().assignedWheels.length > 0) {
      <div class="admin-tab-client__links-list">
        @for (link of client().assignedWheelsResolved; track link.id) {
        <div class="admin-tab-client__link-item">
          <span class="admin-tab-client__link-wheel-name">{{ link.wheelName }}</span>
          <button mat-icon-button (click)="openHistory()" matTooltip="Open Story" class="admin-tab-client__history-button" size="small">
            H
          </button>
          <button
            mat-icon-button
            [cdkCopyToClipboard]="link.linkUrl"
            (click)="onCopyLink(link)"
            matTooltip="Copy link"
            class="admin-tab-client__copy-button"
            size="small"
          >
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
        }
      </div>
      } @else {
      <p class="admin-tab-client__no-links">No wheel links generated yet</p>
      }
    </div>

    <!-- Last Session Date -->
    @if (client().sessions && client().sessions.length > 0) {
    <div class="admin-tab-client__session-section">
      @for (session of client().sessions; track session.id) {
<!--        <span class="admin-tab-client__session-label">{{ session.submittedAt | date }}</span>-->
        <!--            <span class="admin-tab-client__session-date">{{ formatLastSession(client) }}</span>-->
        <span class="admin-tab-client__session-date">{{ session.submittedAt | date }}</span>
      }
    </div>
    } @if (client().notes) {
    <div class="admin-tab-client__notes-section">
      <span class="admin-tab-client__notes-label">Notes:</span>
      <p class="admin-tab-client__notes-text">{{ client().notes }}</p>
    </div>
    }
  </div>
</div>
